import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { FormImagesComponent } from './form-images/form-images.component';
import { TrackingComponent } from './tracking/tracking.component';
import { StatusComponent } from './tracking/status/status.component';
import { ProofLifeComponentsModule } from './components/components.module';
import { ButtonCertificateModule } from './components/button-certificate/button-certificate.module';
// import { PersonValidateService } from '@/services/person-validate/person-validate.service';
// import { DeviceService } from '@/services/device/device.service';
// import { UserService } from '@/services/user-auth/user.service';
import { PipesModule } from './pipes/pipes.module';

@NgModule({
    imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, ProofLifeComponentsModule,
        ButtonCertificateModule, PipesModule
        // ComponentsModule, ButtonCertificateModule, PipesModule
    ],
    declarations: [TrackingComponent, StatusComponent],
    exports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, ProofLifeComponentsModule,PipesModule],
    providers: [
        // UserService, PersonValidateService, DeviceService
    ]
})
export class ProofOfLifeModule {}
